import React from 'react';
import { Group } from '../../../../../redux/groups/api/group.model';
import { Device } from '../../../../../redux/commander/api/device.model';
import {
  AccordionLight,
  AccordionSummaryLight,
  VIEW_TYPE,
} from '../../../../../theme/components';
import { getPolyglot } from '../../../../../i18n';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import EmptyStateStoreCard from './EmptyStateStoreCard';
import GroupsOverview from '../../../../../components/DeviceManager/Group/Overview/GroupsOverview/GroupsOverview';

interface ListEntitiesProps {
  groupsResults: Group[];
  devicesResults: Device[];
  view: VIEW_TYPE;
  groupId: string;
  group?: Group;
}
const FreshWatchListEntities = ({
  groupsResults,
  devicesResults,
  view,
  groupId,
  group,
}: ListEntitiesProps) => {
  const polyglot = getPolyglot();

  let title = polyglot.t('freshwatch.store.companies');
  if (groupId) {
    title = polyglot.t('freshwatch.store.stores');
  }

  return (
    <div>
      {groupsResults.length > 0 ? (
        <AccordionLight defaultExpanded={true}>
          <AccordionSummaryLight
            id="accordion-groups-title"
            aria-controls="accordion-groups-title"
            expandIcon={<GridExpandMoreIcon />}
          >
            <Typography variant="h5">{title}</Typography>
          </AccordionSummaryLight>
          <div>
            <GroupsOverview groups={groupsResults} view={view} />
          </div>
        </AccordionLight>
      ) : (
        <EmptyStateStoreCard />
      )}
    </div>
  );
};

export default FreshWatchListEntities;
